'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _productLabelUpload = require('./product-label-upload.html');

var _productLabelUpload2 = _interopRequireDefault(_productLabelUpload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _productLabelUpload2.default,
  bindings: {
    onProductLabelChanged: '&',
    labelText: '@',
    labelClass: '@',
    iconClass: '@',
    productId: '<',
    showPreview: '<',
    isAbbreviated: '<',
    buttonWidth: '@',
    locked: '<'
  },
  controller: function () {
    function ProductLabelUploadComponent(EventEmitter) {
      'ngInject';

      _classCallCheck(this, ProductLabelUploadComponent);

      Object.assign(this, {
        EventEmitter: EventEmitter
      });
    }

    _createClass(ProductLabelUploadComponent, [{
      key: 'onFileChanged',
      value: function onFileChanged(productLabel) {
        this.onProductLabelChanged(this.EventEmitter({
          productLabel: productLabel,
          productId: this.productId
        }));
      }
    }]);

    return ProductLabelUploadComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/common/product-label-upload/product-label-upload.component.js